import { Routes } from '@angular/router';
import { FileUploadListComponent } from './pages/file-upload-list/file-upload-list.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { AuthenticatedGuard } from './shared/guards/authenticated.guard';
import { NotAuthenticatedGuard } from './shared/guards/not-authenticated.guard';
import { DefaultPageComponent } from './pages/default-page/default-page.component';

export const routes: Routes = [
  {
    path: 'sign-in',
    loadComponent: () => LoginPageComponent,
    canActivate: [NotAuthenticatedGuard],
  },
  {
    path: 'default-page',
    loadComponent: () => DefaultPageComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'folders/:folderId',
    loadComponent: () => FileUploadListComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: '**',
    redirectTo: 'sign-in',
  },
];
